<template>
  <div class="cepingReport">
    <DownloadProgress
      :totalPages="totalPages"
      :currentPage="currentPage"
      v-show="isDownloading"
    ></DownloadProgress>
    <div class="pageInnerBox" style="width: 900px; margin: 0 auto">
      <div class="pageCover">
        <div class="page_index page_shadow pdf-page">
          <div class="logoBox">
            <!-- <img :src="this.headerLogoAddress + this.headerLogo" alt="" /> -->
            <img :src="this.headerLogo" alt="" />
          </div>
          <div class="header">
            <h3>生 涯 测 评 报 告</h3>
            <p>Career Orientation Evaluation Report</p>
          </div>
          <div class="mian">
            <!-- <div>
              
            </div> -->
            <p>
              <span class="name">姓名 </span
              > :<span class="user"> {{userName}}</span>
            </p>
            <p>
              <span class="name">性别 </span
              > :<span class="user"> {{ sex }}</span>
            </p>
            <p>
              <span class="name">高考年份 </span
              > :<span class="user"> {{ collegeYear }}</span>
            </p>
          </div>
        </div>
        <div class="page_msg page page_shadow pdf-page">
          <div class="top_header_box">
            <img :src="this.headerLogo" alt="" />
            <div class="line_box">
               <img class="line_border" src="../../../../public/imgs/wayToStudyWays/report/border_de.png" alt="">
              <p>
                <img
                  src="../../../../public/imgs/cepingreport/page_feng.png"
                  alt=""
                />
                测评背景
              </p>
            </div>
          </div>
          <div class="line_border_title">
            <p>测评背景</p>
            <p class="line"></p>
          </div>
          <div class="page_msg_mian">
            <p>
              当前高中新课程标准业已实施，新高考改革稳步推进，在升学规划上赋予学生更多的选择权，更加尊重其自我兴趣、认知与个性发展。学科、专业选择的灵活自主化和升学途径的丰富化，让中学生和家长在关注能否考上大学的同时，也更加重视如何选择适配的专业和职业，希望高中阶段的生涯决策能够为理想人生打下坚定基础。面对如此形势，高中生除了努力做好学习成绩准备，还要尽早建立专业及职业目标，让学海泛舟受到生涯期待的指引。
            </p>
            <p>
              研究表明，大学生专业满意度的影响因素包括：专业是否与兴趣等个人特征相符合、专业是否有良好的就业前景等；兴趣爱好是影响专业满意度的重要因素，而一味追求热门与就业前景会降低专业满意度。反观现实，个人特征也是相对更稳定可控的，就业形势常因人才竞争、市场需求变化等而出现不可预测的走向，以职业定专业的做法无法避免专业喜好的偏差，且在一定程度上限制了未来发展的更多可能性。
            </p>
            <p>
              因此，本生涯测评秉持“先专业，后职业”的规划理念，着重从人格特性、职业兴趣和智能水平三大个体特质出发，同时进行个体评估和本科专业类别画像，将结果进行科学匹配，最终得到更加适合参测学生的专业选项；同时，基于最新的标准职业体系，向其推荐对应的职业选项，并结合职业价值观信息，提供规划建议；此外了解学生的心理适应性状况，保障生涯底层依托。总体而言，本测评系统立足生涯规划、心理学的理念和方法完成科学搭建，通过个体评估和综合匹配输出准确结果，旨在为中学生的专业填报和职业定向等提供有价值的参考。
            </p>
          </div>
          <div class="page_img_box">
            <img
              src="../../../../public/imgs/cepingreport/page_msg.png"
              alt=""
            />
          </div>
          <div class="page_msg_footer">
            <p>
              本报告首先呈现信度信息和测评结果总览，说明报告的可应用程度及各部分所得的主要结果。第一至四部分对人格、智能、职业倾向和心理适应性的结果进行呈现和解析，展示内部探索结果和生涯规划依据。第五、六部分呈现专业推荐和职业推荐的具体信息，为生涯发展提供指引。
            </p>
          </div>
          <div class="page_msg_footer2">
            <p><span>*</span> 版权声明</p>
            <p>
              本报告内容属于个人隐私，请注意保密，并须在生涯咨询师等专业人士的指导下使用。
            </p>
            <p>
              本报告的所有权受到版权保护，归北京和气聚力教育科技有限公司所有。
            </p>
          </div>
        </div>
      </div>
      <div class="pageInner">

      </div>
      <div class="page2 page_shadow2 page_shadow pdf-page">
        <div class="page_end_bg"></div>
      </div>
      <div class="get_pdf">
        <div class="inner">
          <div class="btn_pdf" @click="goDownload()">下载报告</div>
        </div>
      </div>

      
    </div>
    <div class="loading" v-show="isLoading">
        <Loading></Loading>
      </div>
    <div class="pdf">
      <PageList
        
        :headerLogo="headerLogo"

        :PageList="PageList"
      ></PageList>
      <PagePart
        :PagePart="PagePart"
        :resultOverview="resultOverview"
      ></PagePart>
      <PagePart3 :mbti="mbti"></PagePart3>
      <PagePart4 :intelligent="intelligent"></PagePart4>
       <PagePart5
        :profession="profession"
        :hobby="hobby"
        :threeCategory="threeCategory"
      ></PagePart5>
      <PagePart6 :mindResult="mindResult" :mind="mind"></PagePart6>
      <PagePart1 :professionalRecommend="professionalRecommend"></PagePart1>
      <PagePart2 :careerRecommend="careerRecommend"></PagePart2>
      
      <appendixPage1 :appendix="appendix"></appendixPage1>
      <postscript></postscript>
      <pageEnd></pageEnd>
    </div>
  </div>
</template>

<script>
import PageIndex from "./components3/pageIndex.vue"; //封面
import PageList from "./components3/pageList.vue"; //目录
import PagePart from "./components3/pagePart.vue"; //页面
import PagePart1 from "./components3/pagePart1.vue"; //页面
import PagePart2 from "./components3/pagePart2.vue"; //页面
import PagePart3 from "./components3/pagePart3.vue";
import PagePart4 from "./components3/pagePart4.vue";
import PagePart5 from "./components3/pagePart5.vue";
import PagePart6 from "./components3/pagePart6.vue";
import appendixPage1 from "./components3/appendixPage1";
import postscript from "./components3/postscript";
import pageEnd from "./components3/pageEnd.vue";
import DownloadProgress from '../../../components/learningAbility/DownloadProgress.vue';
import Loading from '../../../components/learningAbility/Loading2.vue';
export default {
  components: {
    PageIndex,
    PageList,
    PagePart,
    PagePart1,
    PagePart2,
    PagePart3,
    PagePart4,
    PagePart5,
    PagePart6,

    appendixPage1,
    postscript,
    pageEnd,
    Loading,
    DownloadProgress
  },
  data() {
    return {
      userName: "", //用户名字
      sex: "", //用户性别
      collegeYear: "", //
      // headerLogoAddress: "http://a.xuematech.com/data",
    //  headerLogo: "/agent/20190630/1561878077207.png",
      headerLogo: "",
      htmlTitle: "",
      PagePart: {}, //信度指数
      resultOverview: {}, //测评结果总览
      careerRecommend: [], //推荐职业
      intelligent: [],
      mbti: {}, //人格特性
      hobby: {}, //兴趣倾向
      profession: {}, //职业倾向
      mind: {}, //心里适应性
      mindResult:[],
      appendix: [], //附录
      radarChart: [], //雷达图
      radarValue: [], //雷达图
      Data: [], //柱状图
      radarZhuData: [], //柱状图name
      radarZhuVal: [], //柱状图val
      threeCategory: [], //职业价值解读
      PageList: [], //目录
      professionalRecommend: [], ////专业推荐
      options: {},
      options2: {},
      options3: {},
      threeYard:'',
      careerLinks: [], //关系图
      nameData: [],
      bgArr: [], //八卦
      bgNewArr:["R-实际型","C-传统型","E-企业型","S-社会型","A-艺术型","I-研究型"],
      bgNewArr2:[],
      isLoading: true,
            isDownloading: false, //是否正在下载
            totalPages: 1, //总页数
            currentPage: 0,//当前页
    };
  },
  created() {
    this.getUserNameIfon();
  },
  mounted() {
    
  },
   watch: {
        isDownloading() {
            let isDownloading = this.isDownloading;
            if(isDownloading) {
                document.body.style.overflow='hidden';
            }else {
                document.body.style.overflow='visible';

            }
        }
    },
  methods: {
    goDownload() {

      window.scrollTo(0, 0);
      this.isDownloading = true;
      this.getPdf(this.htmlTitle);
    },
    getUserNameIfon() {
      let id = this.$route.query.id;
      let url = "/report/getStudentInfoByReportId";
      this.$ajax
        .post(`${this.G_capi}${url}`, {
          // reportId: '2e326a5975e24d3ab5f5fb2cdfdeb893',
          reportId:id
        })
        .then((res) => {
          console.log(res);

          this.userName = res.data.data.baseInfo.name;
          this.sex = res.data.data.baseInfo.sex;
          this.collegeYear = res.data.data.baseInfo.collegeYear;
          this.headerLogo = res.data.data.baseInfo.headerLogo;
       
          this.htmlTitle = this.userName + "-生涯测评报告";
          this.getReportData();
        });
    },
    getReportData() {
      let id = this.$route.query.id;
     // reportId: '02b4998babda49d58a0a7bb7c3c6211a',
      let url = "/report/getReportByReportId";
      this.$ajax
        .post(`${this.G_capi}${url}`, {
          // reportId: '2e326a5975e24d3ab5f5fb2cdfdeb893',
          reportId:id
        })
        .then((res) => {
          console.log(res);
       if(res.data.code == 2000){
            this.isLoading = false;
          this.PagePart = res.data.data.reliabilityIndex; //信度指数
          this.resultOverview = res.data.data.resultOverview; //测评结果总览
          this.PageList = res.data.data.catalog; //目录
         
          this.professionalRecommend = res.data.data.professionalRecommend; //专业推荐
          this.careerRecommend = res.data.data.careerRecommend; //推荐职业
          this.careerLinks = res.data.data.careerLinks; //关系图
          this.careerNameData = res.data.data.careerNameData; //关系图
          const color1 = "#1BCFA0";
          let colorArr = [
            "#F6A724",
            "#F6A724",
            "#C7CE22",
            "#5CBF98",
            "#47B7EA",
            "#1CA4B6",
          ];
         
          this.careerNameData.forEach(node => {
            if(node.category === 0){
                node.label={
                  color: "#000",
                  fontWeight:"bold",
                  fontSize: 16
				        }
              }
          })
       
          this.mbti = res.data.data.mbti; //人格特性
          this.intelligent = res.data.data.intelligent; //智能水平
          this.hobby = res.data.data.hobby; //兴趣倾向

          this.radarChart = res.data.data.hobby.radarChart; //雷达图
          this.threeYard = res.data.data.hobby.threeYard
          for (var i = 0; i < this.radarChart.length; i++) {
            this.bgArr.push({
              name: this.radarChart[i].type + "-" + this.radarChart[i].name,
              value: this.radarChart[i].value,
              max: 20,
              type: this.radarChart[i].type
            });
          }
          
          for (var i = 0; i < this.threeYard.length; i++) {
            for (var j = 0; j < this.bgArr.length; j++) {
                if (this.threeYard[i] == this.bgArr[j].type) {
                    this.bgArr[j].color = "#1CA4B6"
                    // this.bgArr[j].fontSize = "20"
                }
            }
        }

          for(var i = 0;i<this.bgNewArr.length;i++){
            this.bgArr.forEach((item) => {
             
              if(this.bgNewArr[i] == item.name){
                this.bgNewArr2.push(item)
              }
            })
          }
          for(var i = 0;i<this.bgNewArr2.length;i++){
              this.radarValue.push(this.bgNewArr2[i].value)
          }
        //  this.radarValue = res.data.data.hobby.radarValue; //雷达图
          this.threeCategory = res.data.data.profession.threeCategory; //职业价值解读
          this.Data = res.data.data.profession.data; // 柱状图
          this.profession = res.data.data.profession; //职业价值观
          this.mind = res.data.data.mind; //心里适应性
          this.mindResult = res.data.data.mind.result
          this.appendix = res.data.data.appendix; //附录
          console.log(this.appendix)
          for (var i = 0; i < this.Data.length; i++) {
            this.radarZhuData.push(this.Data[i].name);
            this.radarZhuVal.push(this.Data[i].value);
          }

          this.$nextTick(() => {
            this.drawLine();
            this.drawBagua(this.bgNewArr2);
           this.countPage();
            this.drawZhu(this.radarZhuVal);
            this.setCanvas();
          });
         }
        });
    },

   
    countPage() {

      let html1 = '<div class="page page_shadow pdf-page">';
      let html2 = "</div></div>";
      let allHtml =
        '<div class="page pdf-page page_shadow"><p class="big_page_number">1</p>';

      let pageNumber = 1;
      let height = 1120;
      let page_content_height = 0;
      // console.log($(".page_js").prop("outerHTML"));
      var that = this
      $(".content").each(function (item,index) {
       
      
        let nowHtml = $(this).prop("outerHTML");
        
       
        
        
        // let nowHeight = $(this).innerHeight();
        let nowHeight = $(this).outerHeight(true);
       
        page_content_height += nowHeight;


        if (page_content_height <= height) {
          allHtml = allHtml + nowHtml;

        } else {
          pageNumber++
          let headerHtml =
            '<div class="top_header_box"><img src="'+ that.headerLogo +'" alt=""><div class="line_box"><img class="line_border" src="./imgs/wayToStudyWays/report/border_de.png" alt=""><p><img src="./imgs/cepingreport/page_feng.png" alt=""><span></span></p></div></div>';
          let elPageNumber =
            '<p class="big_page_number">' + pageNumber + "</p>";
          page_content_height = nowHeight + 80;
          allHtml =
            allHtml + html2 + html1 + headerHtml + nowHtml + elPageNumber;
        }
      });
      allHtml = allHtml + html2;
      // console.log(allHtml)
      // $('.content').prepend(headerHtml)
      $(".pageInner").append(allHtml);
      $(".pdf").remove()
      
      this.countListPage();
      this.$nextTick(() => {
        var echarts = require("echarts");
        var echarts2 = require("echarts");
        var echarts3 = require("echarts");
        var myChart = echarts.init(document.getElementById("main"));
        var myChart2 = echarts2.init(document.getElementById("Gossip"));
        var myChart3 = echarts2.init(document.getElementById("lineTu"));
        myChart.setOption(this.options);
        myChart2.setOption(this.options2);
        myChart3.setOption(this.options3);
      });
    },
    countListPage() {
      let arr = []
       let arrName = ["目录","报告信度","人格特性","智能水平","兴趣倾向","心里适应性","专业推荐","职业推荐","附录","后记"]
      $(".career_page").each(function (idx) { //目录页数
        let number = $(this).parents(".pdf-page").find(".big_page_number").text();
        $(".mulu_page").eq(idx).find(".page_number2").html(number);
      });
     $(".header_title_page").each(function(idx){
        let number = $(this).parents(".pdf-page").find(".big_page_number").text();
        arr.push(number)
        
     })
     for(var i = 0;i<arr.length;i++){   //页眉
       $(".top_header_box").each(function(index){

          let number = $(this).parents(".pdf-page").find(".big_page_number").text();
          // if(Number(arr[i])<=Number(number) &&Number(arr[i]) == Number(number) && Number(arr[i+1]) > Number(number)){
          // $(this).find("span").html(arrName[i])
          // }
          if(Number(arr[i])<=Number(number)){
            $(this).find("span").html(arrName[i])
          }else if(Number(arr[i+1]) < Number(number)){
            $(this).find("span").html(arrName[i])
          }else if(Number(arr[i]) == Number(number)){
            $(this).find("span").html(arrName[i])
          }
       })
       
     }
     $(".mulu_page .page_number2").each(function(idx){

       let number=(Number($(this).html())-Number(arr[1])+1)
       number<=0?$(this).html(''):$(this).html(number)  
     })
     $(".big_page_number").each(function(idx){
      
       let number=(Number($(this).html())-Number(arr[1])+1)
      number<=0?$(this).html(''):$(this).html(number)  
     })
    },
    drawLine() {
      this.options = {
        title: {},

        series: [
          {
            type: "graph",
            layout: "force",
            force: {
              repulsion: 800,
              edgeLength: 50,
            },
            roam: true,
            label: {
              // formatter: function (params,ticket,callback) {
              //     console.log(params)
              // },
              normal: {
                show: true,
                formatter: function (params) {

                    var sss=params.name
      
                    var reg=/\d/;
                var result=reg.test(sss);
                    var arr=[]
                    
                    if(result){
                      arr= sss.split(" ")
                      
                      var strs = arr[0].split('');
                      var str = ''
                      for(var i = 0, s; s = strs[i++];) { //遍历字符串数组
                            str += s;
                            if(!(i % 7)) str += '\n'; //按需要求余
                        }
                      
                      return str+"\n"+arr[1];

                    }else{
                        var strs = sss.split(''); //字符串数组
                        var str = ''
                        for(var i = 0, s; s = strs[i++];) { //遍历字符串数组
                            str += s;
                            if(!(i % 7)) str += '\n'; //按需要求余
                        }
            
                      return str;
                    }
                
                  }
                  
                },
              },
            categories: [],
            // color: [ '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#cfb850', '#4ee0d7', '#e3698c', '#eca389', '#6939e4', '#9f73c7', '#6056e9', '#c97648', '#0d5d64'],
            data: this.careerNameData,
            links: this.careerLinks,
            lineStyle: {
              normal: {
                opacity: 0.9,
                width: 1,
                curveness: 0,
              },
            },
          },
        ],
      };
    },
    drawBagua(value) {
      
      var iarr = []
      this.options2 = {
        tooltip: {
          trigger: "item",
        },
        radar: {
          // shape: 'circle',
          name: {
            formatter: function (val) {
                            console.log(val)
                            let values = false
                            for (let i = 0; i < value.length; i++) {
                                if (value[i].name == val && value[i].color) {
                                    values=true
                                   break
                                }
                            }
                            if(values){
                                return '{a|' + val + '}'
                            }else{
                                return '{b|' + val + '}'
                            }
                           
                        },
           
            rich: {
              a: {
                 color: "#1CA4B6",
                fontSize: 18,
              },
              b: {
                color: "#2F2F2F",
                fontSize: 14,
               
              },
            },
            textStyle: {
              color: "#4D4D4D",
              fontSize: 14,
              fontWeight: "bold",
              padding: [3, 5],
            },
          },

          axisLine: {
            //指向外圈文本的分隔线样式
            lineStyle: {
              type: "dashed",
            },
          },
          splitArea: {
            show: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          radius: "70%",
          center: ["50%", "50%"],
          // indicator: this.bgArr,
          indicator:value
        },
        series: [
          {
            name: "测评结果",
            type: "radar",
            // areaStyle: {normal: {}},
            data: [
              {
                value: this.radarValue,
                name: "测评结果",
                label: {
                  show: true,
                  formatter: function (params) {
                    iarr.push(params)
                    // if (params.value <= 10) {
                    //   return "{a|" + params.value + "}";
                    // } else {
                    //   return "{b|" + params.value + "}";
                    // }
                    for (var i = 0; i < value.length; i++) {
                                if (value[i].value == params.value && value[iarr.length - 1].color) {
                                    return '{b|' + params.value + '}';
                                }



                            }
                  },
                  rich: {
                    a: {
                      color: "#2F2F2F",
                      fontSize: 14,
                    },
                    b: {
                      color: "#1CA4B6",
                      fontSize: 18,
                    },
                  },
                },
              },
            ],
            areaStyle: {
              color: "rgba(184,232,255,0.8)",
            },
            lineStyle: {
              color: "#1CA4B6",
              width: 2,
            },
            label: {
              show: true,
              position: "top",
              fontSize: 14,
              color: "#2F2F2F",

              // fontWeight:'bold'
            },
            symbol: "circle",
            symbolSize: 4,
            showAllSymbol: false,

            itemStyle: {
              color: "white",
              borderColor: "#1CA4B6",
              borderWidth: 2,
            },
          },
        ],
      };
    },
    drawZhu(value) {
      console.log(value)
     
      var bkData = [100, 100, 100, 100, 100, 100, 100, 100];
      this.options3 = {
        backgroundColor: "",
        color: ["#3398DB"],
        tooltip: {
          show: false,
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              opacity: 0,
            },
          },
          backgroundColor: "rgb(7,55,133)",
          borderColor: "#0daee9",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "10%",
          height: "85%",
          containLabel: true,
          z: 22,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true, // 坐标轴两边留白
            gridIndex: 0,
            data: this.radarZhuData,
            axisLabel: {
              textStyle: {
                fontSize: 12,
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,.8)",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            min:0,
            max:30,
            minInterval:5,
            interval:5,
            name: "分值",
            type: "value",
            nameTextStyle: {
              color: "rgb(170,170,170)",
            },
            gridIndex: 0,
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "rgba(224, 222, 222, 1)",
              },
            },
            axisLabel: {
              color: "rgba(0,0,0,.8)",
              fontSize: 12,
              formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                color: "rgba(224, 222, 222, 1)",
              },
            },
          },
          {
            type: "value",
            show: false,
            gridIndex: 0,
            // min: min,
            // max: 6,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#95a2aa",
              fontSize: 14,
              formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)",
              },
            },
          },
        ],
        series: [
          {
            // name: "高发事件统计",
            type: "bar",
            barWidth: "30%",
            xAxisIndex: 0,
            yAxisIndex: 0,
            itemStyle: {
              // normal: {
              //   color: function (params) {
              //     return colors[params.dataIndex];
              //   },
              // },
              color:function(params){
                function f(a,b){
                  return - (a-b)
                }
                value.sort(f)
              
                if(value[0] == params.value){
                  return "#FEAE3B"
                }else if(value[1] == params.value){
                  return "#1CA4B6"
                }else if(value[2] == params.value){
                  return "#1CA4B6"
                }else {
                  return "#C5E419"
                }
              }
            },
            label: {
              show: true,
              position: "top",
            },
            data: value,
            zlevel: 11,
          },
          {
            name: "背景",
            type: "bar",
            barWidth: "30%",
            xAxisIndex: 0,
            yAxisIndex: 1,
            barGap: "-100%",
            data: bkData,
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0)",
                barBorderRadius: [0, 0, 0, 0],
              },
            },
            tooltip: {
              show: false,
            },
            zlevel: 9,
          },
        ],
      };
    },
    setCanvas() {
      //   let canvasId = this.canvasId;
      let tableArr = ["学习焦虑", "对人焦虑", "自责倾向", "冲动倾向"]
      let arr = [];
       for (var i = 0; i < tableArr.length; i++) {
        this.mindResult.forEach((item) => {
          if (tableArr[i] == item.name) {
            arr.push(item);
          }
        });
      }
      for (var i = 0; i < arr.length; i++) {
        var key = "canvasId" + (i + 1);

        let ctx = document.getElementById(key).getContext("2d");

        //常模
        ctx.beginPath(); //起始路径，重置当前路径
        // ctx.strokeStyle="#FCE5E0";
        ctx.strokeStyle = "rgba(121,119,119,.3)";

        ctx.lineWidth = 55; //设置或返回当前的线条宽度。
        ctx.lineCap = "butt"; //设置或返回线条的结束端点样式。
        ctx.arc(
          126,
          127,
          60,
          (0.825 + ((1.5 / 5) * 244) / 180) * Math.PI,
          (((3.5 / 5) * 244) / 180 + 0.825) * Math.PI
        ); //4个刻度平分180°
        
        ctx.stroke();
        ctx.closePath();

       ctx.beginPath(); //起始路径，重置当前路径
        // ctx.strokeStyle="#FCE5E0";
        ctx.strokeStyle = "rgba(121,119,119,.2)";

        ctx.lineWidth = 55; //设置或返回当前的线条宽度。
        ctx.lineCap = "butt"; //设置或返回线条的结束端点样式。
        ctx.arc(
          126,
          127,
          60,
          (0.825 + ((0 / 5) * 244) / 180) * Math.PI,
          (((1.5 / 5) * 244) / 180 + 0.825) * Math.PI
        ); //4个刻度平分180°
        
        ctx.stroke();
        ctx.closePath();

        //橙色圈
        ctx.beginPath(); //起始路径，重置当前路径
        let lingrad = ctx.createLinearGradient(40, 20, 215, 20); //创建线性渐变，颜色渐变
        lingrad.addColorStop(0, "#FDAB74");
        lingrad.addColorStop(1, "#FE8E84");

        ctx.strokeStyle = lingrad; //设置或返回用于笔触的颜色、渐变或模式。
        ctx.lineWidth = 10; //设置或返回当前的线条宽度。
        ctx.lineCap = "round"; //设置或返回线条的结束端点样式。

        ctx.arc(
          127,
          127,
          101,
          0.825 * Math.PI,
          (((arr[i].value / 5) * 244) / 180 + 0.825) * Math.PI
        ); //4个刻度平分180°
        ctx.stroke();
        ctx.closePath();
        
      }
    },
  },
};
</script>

<style scoped>


.top_header_box .line_box .line_border{
  position: absolute;
  top:120px;
  width: 620px;
}

.blank_page{
  width: 100%;
  height: 200px;
}
.pageInnerBox {
  position: relative;
}
.cepingReport {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #e8e8e8;
  color: #333;
  font-size: 16px;
}
.cepingReport .loading{
      position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999999999;
    background-color: #fff;
}
.pdf {
  width: 900px;
  margin: 0 auto;
  /* background-color: #fff; */
}
.inner {
  position: relative;
  width: 900px;
  margin: 0 auto;
}
.get_pdf {
  height: 0;
  width: 100%;
  position: fixed;
  top: 30%;
  left: 200px;
}
.btn_pdf {
  position: absolute;
  right: 150px;
  width: 40px;
  text-align: center;
  background-color: #2c8ffc;
  color: #fff;
  cursor: pointer;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 5px 10px;
}

.page_index {
  width: 900px;
  height: 1300px;
  background: url("../../../../public/imgs/cepingreport/cepingReport.png");
  background-size: 900px 1300px;
  position: relative;
  background-size: cover;
  margin-bottom: 20px;
}
.logoBox {
  position: absolute;
  width: 140px;
  height: 70px;
  top: 40px;
  left: 50px;
}
.header {
  padding-top: 152px;
  height: 700px;
  text-align: center;
}
.header h3 {
  line-height: 100px;
  font-size: 74px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
}
.header p {
  font-size: 26px;
  line-height: 40px;
  display: inline-block;
  width: 566px;
  text-align: center;
  border-radius: 20px;
  color: #fff;
  background-color: #1ca4b6;
}
.mian {
  margin-top: 200px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
}
.mian p {
  margin-top: 15px;
}
.mian p .name {
  display: inline-block;
  width: 80px;
  text-align-last: justify;
}
.mian p .user {
  display: inline-block;
  width: 100px;
  word-break: keep-all;
  white-space: nowrap;
  text-align: left;
  margin-left: 5px;
}
.top_header_box {
  display: flex;
  height: 42px;
  margin-bottom: 40px;
}
.top_header_box .log {
  display: block;
  height: 42px;
}
.top_header_box .line_box {
  padding-top: 20px;
  padding-bottom: 2px;
  flex: 1;
  /* border-bottom: 1px dashed #17abbd; */
}
.top_header_box .line_box p {
  line-height: 20px;
  float: right;
  display: flex;
  align-items: center;
}
.top_header_box .line_box p img {
  margin-right: 4px;
}
.page_shadow .line_border_title p {
  line-height: 42px;
  color: #2f2f2f;
  font-weight: 500;
  font-size: 30px;
}
.page_shadow .line_border_title .line {
  margin-top: 7px;
  height: 2px;
  width: 150px;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#ffb23a),
    to(#19afbf)
  );
  background: linear-gradient(90deg, #ffb23a, #19afbf);
}
.page_msg_mian {
  margin-top: 15px;
}
.page_msg_mian p {
  text-indent: 2em;
  font-size: 15px;
  /* font-weight: 400; */
  color: #2f2f2f;
  line-height: 30px;
}
.page_img_box {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.page_msg_footer,
.page_msg_footer2 {
  margin-top: 15px;
}
.page_msg_footer2{
  margin-top: 2px;
}
.page_msg_footer p,
.page_msg_footer2 p {
  font-size: 15px;
  /* font-weight: 400; */
  color: #2f2f2f;
  line-height: 30px;
}
.page_msg_footer2 span {
  color: red;
}

.page_shadow2 {
  height: 1300px;
  width: 900px;
  margin-bottom: 20px;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
  display: flex;
  align-items: center;
}
.page_msg_footer p {
  text-indent: 2em;
  font-size: 16px;
  font-weight: 400;
  color: #2f2f2f;
  line-height: 26px;
}
/* .page_end_bg{
    width: 100%;
    height: 300px;
    background: #1D9BAC;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.page_end_bg h3{
    font-size: 60px;
    color: #fff;
}
.page_end_bg p{
    color: #fff;
    font-size: 24px;
} */
.page_end_bg {
  width: 100%;
  height: 321px;
  background: url("../../../../public/imgs/cepingreport/end.png");
  background-size: cover;
}
</style>